import { render, staticRenderFns } from "./ReadIndicadorRenderer.vue?vue&type=template&id=a9083c94&"
import script from "./ReadIndicadorRenderer.vue?vue&type=script&lang=js&"
export * from "./ReadIndicadorRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports